import React from 'react';
import config from '../config/config';

const ICON_URLS = {
  search: `${config.icons.baseUrl}${config.icons.search}`,
  close: `${config.icons.baseUrl}${config.icons.close}`,
};

const RESEARCH_MESSAGE = 'このエリアで検索';

/**
 * 再検索ボタンコンポーネント
 */
const ResearchHereButton = ({
  handleResearchHere,
  setIsResearchHereEnabled
}) => {

  return (
    <div className="research-here-container">
      <button
        className="search-here-btn"
        onClick={handleResearchHere}
      >
        <i
          className="svg-icon-blue search-here-icon"
          style={{ backgroundImage: `url(${ICON_URLS.search})` }}>
        </i>
        {RESEARCH_MESSAGE}
        <span
          style={{ marginLeft: '8px' }}
          onClick={(e) => {
            // ボタンのクリックイベントが発生しないようにする
            e.stopPropagation();
            // 閉じるボタンがクリックされたら再検索ボタンを閉じ、新しい検索がされるまで再検索ボタン非表示にする
            setIsResearchHereEnabled(false);
          }}
          role="button"
          aria-label="閉じる"
        >
          <i
            className="svg-icon-blue search-here-close-icon"
            style={{ backgroundImage: `url('${ICON_URLS.close}')` }}
          ></i>
        </span>
      </button>
    </div>
  );
};

export default ResearchHereButton;